<template>
  <div class="container-rules">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.call.tit1') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main right-read">
      <!-- 标题和警告 -->
      <div class="title">{{ $t('lang.call.tit1') }}</div>
      <div class="text1">{{ $t('lang.rule.callWarning') }}</div>
      <!-- call规则 -->
      <div class="title">{{ $t('lang.rule.callRules') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule1') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule2') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule3') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule4') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule5') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule6') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule7') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule8') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule9') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule10') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule11') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule12') }}</div>
      <div class="text1">{{ $t('lang.rule.callRule13') }}</div>
      <br />
      <!-- chat规则 -->
      <div class="title">{{ $t('lang.rule.chatRules') }}</div>
      <div class="text1">{{ $t('lang.rule.chatWarning') }}</div>
      <div class="text1">{{ $t('lang.rule.chatRules1') }}</div>
      <div class="text1">{{ $t('lang.rule.chatRules2') }}</div>
      <div class="text1">{{ $t('lang.rule.chatRules3') }}</div>
      <div class="text1">{{ $t('lang.rule.chatRules4') }}</div>
      <div class="text1">{{ $t('lang.rule.chatRules5') }}</div>
      <div class="text1">{{ $t('lang.rule.chatRules6') }}</div>
      <br />
      <!-- 账户规则 -->
      <div class="title">{{ $t('lang.rule.accountRules') }}</div>
      <div class="text1">{{ $t('lang.call.conTit3') }}</div>
      <div class="text1">{{ $t('lang.rule.accountRules1') }}</div>
      <div class="text1">{{ $t('lang.rule.accountRules2') }}</div>
      <div class="text1">{{ $t('lang.rule.accountRules3') }}</div>
      <div class="text1">{{ $t('lang.rule.accountRules4') }}</div>
      <div class="text1">{{ $t('lang.rule.accountRules5') }}</div>
      <div class="text1">{{ $t('lang.rule.accountRules6') }}</div>
      <br />
      <!-- 结语 -->
      <div class="text1">{{ $t('lang.rule.endText') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.custom-nav-block {
  background-color: #f9f9fb;
}
.container-rules {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
  .main {
    padding: 20px 16px;
    color: #666666;
    line-height: 20px;
    .title {
      font-size: 14px;
      color: #000;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .text1 {
      width: 100%;
      font-size: 14px;
      padding: 0 5px;
      font-family: Inter-Regular;
      font-weight: 400;
      color: #333333;
      margin-bottom: 12px;
    }
    .text2 {
      width: 100%;
      padding: 0 0 5px 15px;
      font-size: 13px;
      font-family: Inter-Regular;
      font-weight: 400;
      color: #666666;
    }
    i {
      color: #333333;
    }
    .text5 {
      color: #000;
    }
    .table {
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.15);
      border-radius: 8px;
      margin: 15px 0;
      th {
        width: 100%;
        padding: 10px 0;
        background: #f2f3f8;
        font-size: 12px;
        font-family: Inter-Bold, Inter-Regular;
        font-weight: bold;
        color: #333333;
        line-height: 35px;
      }
      .th1 {
        border-radius: 8px 0 0 0;
      }
      .th3 {
        border-radius: 0 8px 0 0;
      }
      tr {
        display: flex;
        justify-content: space-between;
      }
      td {
        height: 55px;
        line-height: 55px;
        font-size: 14px;
        font-family: Inter-Regular;
        font-weight: 400;
        color: #333333;
      }
      .level {
        width: 40px;
        text-align: center;
      }
      .earning {
        flex: 1;
        width: 180px;
        text-align: center;
      }
      .rate {
        width: 95px;
        text-align: center;
      }
    }
  }
}
</style>
